import React from "react";
import UsersListPanel from "./UsersListPanel";
import Modal from "./UsersModal";
import useUsersLoad from "./useUsersLoad";
import Select from "./UsersSelect";
import Swal from "sweetalert2";
import { Button, Form, Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { tambahUser, getAllClient } from "stores";
import { useDispatch, useSelector } from "react-redux";
import { getAllUser } from "stores";
import { editStatusUser } from "stores";

function ListUser() {
  const dispatch = useDispatch();
  const listState = useUsersLoad(getAllUser, dispatch);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const storeClient = useSelector((state) => state.clientReducer);
  const user = useSelector((state) => state.userReducer);
  const auth = useSelector((state) => state.authReducer);

  const [pilihJabatan, setPilihJabatan] = React.useState(null);
  const [role, setRole] = React.useState("");
  const [listUser, setListUser] = React.useState([]);
  const [pilihClient, setPilihClient] = React.useState(null);
  const [idUser, setIdUser] = React.useState("");
  const [idClient, setIdClient] = React.useState("");
  const [modalUser, setModalUser] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [nama, setNama] = React.useState("");
  const [nopeg, setNopeg] = React.useState("");
  const [listClient, setListClient] = React.useState([]);
  const [status, setStatus] = React.useState("");

  const submitUser = () => {
    tambahUser({
      nama: nama,
      nopeg: nopeg,
      role: role,
      idClient: idClient,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            showConfirmButton: false,
            title: response.data.message,
            timer: 1000,
          });
          handleModalClose();
          getAllUser(dispatch);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
      });
  };

  const handleModalClose = () => {
    setModalUser(false);
    setPilihClient(null);
    setPilihJabatan(null);
    setIdClient("");
    setPilihJabatan("");
  };

  const checkStatus = () => {
    if (status.value === undefined || status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status wajib diisi !",
      });
    } else {
      submitEditStatus();
    }
  };

  const submitEditStatus = () => {
    editStatusUser({
      idUser: idUser,
      status: status.value,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllUser(dispatch, { idClient: "" });
          setModalEdit(false);
          setStatus("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  // const submitEdit = () => {
  //   Swal.fire({
  //     title: "Tunggu ...",
  //     didOpen() {
  //       Swal.showLoading();
  //     },
  //     allowOutsideClick: false,
  //     allowEscapeKey: false,
  //     allowEnterKey: false,
  //   });
  //   if (nama === "" || nopeg === "" || pilihClient === "") {
  //   } else {
  //     tambahUser({
  //       nama: nama,
  //       nopeg: nopeg,
  //       role: role,
  //       idClient: idClient,
  //     }).then((response) => {
  //       console.log(response);
  //       if (response === 200) {
  //         Swal.close();
  //         setModalPenempatan(false);
  //         setIdClient("");
  //         setPilihClient("");
  //       }
  //     });
  //   }
  // };

  React.useEffect(() => { getAllClient(dispatch); }, [dispatch]);

  React.useEffect(() => {
    let tmp =
      user.listUser &&
      user.listUser.map((val) => {
        return {
          ...val,
          action: (
            <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
              {val.role !== "super admin" ? (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Edit Status</Tooltip>}
                >
                  <Button aria-label="Edit Status" title="Edit Status"
                    variant="light"
                    style={{
                      padding: "8px",
                      borderRadius: "8px",
                      backgroundColor: "#F1F5F9",
                      color: "#0EA5E9",
                      border: "none",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "36px",
                      height: "36px"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#0EA5E9";
                      e.currentTarget.style.color = "#FFFFFF";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#F1F5F9";
                      e.currentTarget.style.color = "#0EA5E9";
                    }}
                    onClick={() => {
                      setSelectedUser(val);
                      setIdUser(val._id);
                      setStatus("");
                      setModalEdit(true);
                    }}
                  >
                    <i className="fas fa-edit"></i>
                  </Button>
                </OverlayTrigger>
              ) : (
                <span style={{ color: "#94A3B8", fontStyle: "italic" }}>-</span>
              )}
            </div>
          ),
        };
      });
    setListUser(tmp);
  }, [user.listUser]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });
    setListClient(tmp);
  }, [storeClient.listClient]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          backgroundColor: "#FEE2E2",
          textColor: "#DC2626",
          icon: "fas fa-times-circle"
        };
      case "aktif":
        return {
          backgroundColor: "#DCFCE7",
          textColor: "#16A34A",
          icon: "fas fa-check-circle"
        };
      default:
        return {
          backgroundColor: "#F1F5F9",
          textColor: "#64748B",
          icon: "fas fa-info-circle"
        };
    }
  };

  const colUser = [
    {
      name: "No",
      width: "80px",
      center: true,
      selector: (row, index) => index + 1,
    },
    {
      name: "Nama",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nama,
    },
    {
      name: "Username",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nopeg,
    },
    {
      name: "Jabatan",
      minWidth: "200px",
      center: true,
      selector: (row) =>
        row.role === "admin"
          ? "Admin"
          : row.role === "client"
            ? "Client"
            : "Super Admin",
    },
    {
      name: "BPD",
      minWidth: "200px",
      center: true,
      selector: (row) => (row.penempatan ? row.penempatan : "-"),
    },
    {
      name: "Status",
      minWidth: "150px",
      center: true,
      selector: (row) => row.status,
      cell: (row) => {
        const statusStyle = getStatusUser(row.status);
        const tampilanLabel = row.status === "aktif" ? "Aktif" : "Tidak Aktif";

        return (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              fontWeight: "600",
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
            }}
          >
            <i className={statusStyle.icon}></i>
            {tampilanLabel}
          </div>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "150px",
      center: true,
      selector: (row) => row.action,
    },
  ];

  return (
    <>
      <Modal
        size="md"
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#E0F2FE", padding: "8px", borderRadius: "10px", color: "#0EA5E9", display: "flex" }}>
                <i className="fas fa-edit"></i>
              </div>
              Edit Status User
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => setModalEdit(false)} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>

          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Form.Group>
                <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Status</label>
                <Select
                  classNamePrefix="react-select"
                  value={status}
                  onChange={(selectedOption) => setStatus(selectedOption)}
                  options={[
                    { value: "true", label: "Aktif" },
                    { value: "false", label: "Tidak Aktif" },
                  ]}
                  placeholder="Pilih status aktif/tidak aktif"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: "10px",
                      borderColor: "#E2E8F0",
                      padding: "2px",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#0EA5E9" }
                    })
                  }}
                />
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => setModalEdit(false)}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#ffffffff", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              variant="primary"
              onClick={checkStatus}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", backgroundColor: "#0EA5E9", border: "none", boxShadow: "0 4px 6px rgba(14, 165, 233, 0.2)" }}
            >
              Simpan Perubahan
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <UsersListPanel title="User" description="Kelola akun administrator dan pengguna sistem."
        data={listUser} columns={colUser} {...listState}
        addLabel="Tambah User" onAdd={() => setModalUser(true)} />

      <Modal
        size="lg"
        show={modalUser}
        onHide={() => {
          handleModalClose();
          setModalUser(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={null}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#E0F2FE", padding: "8px", borderRadius: "10px", color: "#0EA5E9", display: "flex" }}>
                <i className="fas fa-user-plus"></i>
              </div>
              Form Tambah User
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => { handleModalClose(); setModalUser(false); }} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>
          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Nama User</label>
                    <Form.Control
                      onChange={(e) => setNama(e.target.value)}
                      placeholder="Masukkan nama lengkap"
                      type="text"
                      style={{ borderRadius: "10px", padding: "12px 16px", border: "1px solid #E2E8F0" }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Username / No. Pegawai</label>
                    <Form.Control
                      onChange={(e) => setNopeg(e.target.value)}
                      placeholder="Masukkan username"
                      type="text"
                      style={{ borderRadius: "10px", padding: "12px 16px", border: "1px solid #E2E8F0" }}
                    />
                  </Form.Group>
                </Col>
                <Col md={auth.role === "super admin" ? 6 : 12}>
                  <Form.Group className="mb-4">
                    <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Jabatan / Role</label>
                    <Select
                      classNamePrefix="react-select"
                      value={pilihJabatan}
                      onChange={(value) => {
                        setRole(value.value);
                        setPilihJabatan(value);
                      }}
                      options={[
                        { value: "admin", label: "Admin" },
                        { value: "client", label: "Client" },
                      ]}
                      placeholder="Pilih Jabatan..."
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "10px",
                          borderColor: "#E2E8F0",
                          padding: "4px",
                          boxShadow: "none",
                          "&:hover": { borderColor: "#0EA5E9" }
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                {auth.role === "super admin" && (
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Client (BPD)</label>
                      <Select
                        classNamePrefix="react-select"
                        value={pilihClient}
                        onChange={(value) => {
                          setPilihClient(value);
                          setIdClient(value.value);
                        }}
                        options={listClient}
                        placeholder="Pilih BPD..."
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderRadius: "10px",
                            borderColor: "#E2E8F0",
                            padding: "4px",
                            boxShadow: "none",
                            "&:hover": { borderColor: "#0EA5E9" }
                          })
                        }}
                      />
                    </Form.Group>
                  </Col>
                )}
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => { handleModalClose(); setModalUser(false); }}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              onClick={submitUser}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 24px", backgroundColor: "#0EA5E9", border: "none", boxShadow: "0 4px 6px rgba(14, 165, 233, 0.2)" }}
            >
              <i className="fas fa-save mr-2"></i> Simpan Data
            </Button>
          </Modal.Footer>
        </>
      </Modal>
    </>
  );
}

export default ListUser;
